import { KomitentEmail } from "../komitent-email/komitent-email";
import { KomitentTelefon } from "../komitent-telefon/komitent-telefon";
import { KomitentZrc } from "../komitent-zrc/komitent-zrc";

export class KomitentUvozNBS{
    constructor(){}

    ID: number = null;
    Naziv: string = null;
    SNaziv: string = null;
    Pib: string = null;
    MaticniBroj: string = null;
    Adresa: string = null;
    MestoID: string = null;
    Web: string = null;
    Emaili: KomitentEmail[] = null;
    Telefoni: KomitentTelefon[] = null;
    ZiroRacuni: KomitentZrc[] = null;
    TipKomitentaID : number = 1;
    Jbkjs: string = null;

    Deserialize(input:any){
        this.ID = input.ID;
        this.Naziv = input.Naziv;
        this.SNaziv = input.SNaziv;
        this.Pib = input.Pib;
        this.MaticniBroj = input.MaticniBroj;
        this.Adresa = input.Adresa;
        this.MestoID = input.MestoID;
        this.Web = input.Web;
        this.Jbkjs = input.Jbkjs;
        
        if (input.Emaili!=null){
            this.Emaili=[];
            input.Emaili.forEach(Item => {
                return this.Emaili.push(new KomitentEmail().Deserialize(Item))
            });
        }
        if (input.Telefoni!=null){
            this.Telefoni=[];
            input.Telefoni.forEach(Item => {
                return this.Telefoni.push(new KomitentTelefon().Deserialize(Item))
            });
        }
        if (input.ZiroRacuni!=null){
            this.ZiroRacuni=[];
            input.ZiroRacuni.forEach(Item => {
                return this.ZiroRacuni.push(new KomitentZrc().Deserialize(Item))
            });
        }
        return input;

    }

}